import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/Auth/ProtectedRoute";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { VideoProvider } from "@/contexts/VideoContext";
import Login from "@/components/Auth/Login";
import Register from "@/components/Auth/Register";
import EmailVerification from "@/components/Auth/EmailVerification";
import ForgotPassword from "@/components/Auth/ForgotPassword";
import ResetPassword from "@/components/Auth/ResetPassword";
import GameList from "@/components/GameList";
import GamePage from "@/components/GamePage";
import GameForm from "@/components/GameForm";
import PanoramaViewer from "@/components/PanoramaViewer";
import GuessGame from "@/components/GuessGame";
import EditCoordinates from "@/components/EditCoordinates";
import HotspotEditorPage from "@/components/HotspotEditorPage";
import UserProfile from "@/components/UserProfile";
import AdminPanel from "@/components/AdminPanel";
import UserResults from "@/components/UserResults";
import Challenge from "@/components/Challenge";
import PageHeader from "@/components/PageHeader";
import PageTitleUpdater from "@/components/PageTitleUpdater";
import ViralityPage from "@/components/ViralityPage";
import RefLanding from "@/components/RefLanding";
import { useParams } from "react-router-dom";
// Redirect component for old /games/ URLs
const GameRedirect = ({ type }) => {
  const params = useParams();
  const gameId = params.gameId;
  const panoramaId = params.panoramaId;
  const userId = params.userId;
  
  let newPath = `/${gameId}`;
  if (type === 'edit') newPath = `/${gameId}/edit`;
  else if (type === 'guess') newPath = `/${gameId}/guess/${panoramaId}`;
  else if (type === 'user-results') newPath = `/${gameId}/user-results/${userId}`;
  
  // Preserve query parameters during redirect
  const search = window.location.search;
  return <Navigate to={newPath + search} replace />;
};



// Component to redirect old /games/... URLs to new simplified URLs
const RedirectToSimplified = () => {
  const location = window.location;
  const newPath = location.pathname.replace('/games/', '/');
  return <Navigate to={newPath + location.search} replace />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/game">
        <LanguageProvider>
          <VideoProvider>
          <AuthProvider>
          <PageHeader />
          <PageTitleUpdater />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/verify-email/:token" element={<EmailVerification />} />
            
            <Route path="/" element={<GameList />} />

            {/* New simplified game routes */}
            <Route path="/create" element={
              <ProtectedRoute requireRoles={['admin', 'editor']}>
                <GameForm />
              </ProtectedRoute>
            } />

            {/* Old /games/ URLs - redirect to new */}
            <Route path="/games/create" element={<Navigate to="/create" replace />} />
            <Route path="/games/:gameId/edit" element={<GameRedirect type="edit" />} />
            <Route path="/games/:gameId/guess/:panoramaId" element={<GameRedirect type="guess" />} />
            <Route path="/games/:gameId/user-results/:userId" element={<GameRedirect type="user-results" />} />
            <Route path="/games/:gameId" element={<GameRedirect type="game" />} />

            
            
            
            
            
            
            <Route path="/challenge/:challengeId" element={<Challenge />} />
            
            <Route path="/profile" element={
              <ProtectedRoute>
                <UserProfile />
              </ProtectedRoute>
            } />
            
            <Route path="/profile/:userId" element={
              <UserProfile isPublic={true} />
            } />
            
            <Route path="/admin" element={
              <ProtectedRoute requireRoles={['admin']}>
                <AdminPanel />
              </ProtectedRoute>
            } />
            
            <Route path="/view/:panoramaId" element={<PanoramaViewer />} />
            
            <Route path="/edit/:panoramaId" element={
              <ProtectedRoute requireRoles={['admin', 'editor']}>
                <EditCoordinates />
              </ProtectedRoute>
            } />
            
            <Route path="/hotspots/:panoramaId" element={
              <ProtectedRoute requireRoles={['admin', 'editor']}>
                <HotspotEditorPage />
              </ProtectedRoute>
            } />

            {/* Virality / referral system */}
            <Route path="/virality" element={
              <ProtectedRoute>
                <ViralityPage />
              </ProtectedRoute>
            } />
            <Route path="/ref/:slug" element={<RefLanding />} />

            {/* Game pages - must be after all specific routes */}
            <Route path="/:gameId/edit" element={
              <ProtectedRoute requireRoles={['admin', 'editor']}>
                <GameForm />
              </ProtectedRoute>
            } />
            <Route path="/:gameId/guess/:panoramaId" element={<GuessGame />} />
            <Route path="/:gameId/user-results/:userId" element={<UserResults />} />
            <Route path="/:gameId" element={<GamePage />} />
          </Routes>
        </AuthProvider>
        </VideoProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;